export const shopProductsFilters = {
  regions: 'regions',
  segments: 'segments',
  categories: 'categories',
};
